import matchUserAgentWithRegExp from './matchUserAgentWithRegExp';

export default userAgentParam => matchUserAgentWithRegExp(userAgentParam, /^((?!chrome|android).)*safari/i);
